import { render, staticRenderFns } from "./isi_berita.vue?vue&type=template&id=8540accc&"
import script from "./isi_berita.vue?vue&type=script&lang=js&"
export * from "./isi_berita.vue?vue&type=script&lang=js&"
import style0 from "./isi_berita.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports